// extracted by mini-css-extract-plugin
export default {"left_element":"ItemTag_left_element__1lhBZ","right_element":"ItemTag_right_element__WGt+y"};